import {
  type DiscordGuildRole,
  DISCORD_GUILD_ROLE_CLIENT_COLUMNS_CSV,
  DiscordGuildRoleRowResponseSchema,
} from '@playerbase/types';

import { supabase } from '../lib/supabase.js';

// ---------------------------------------------------------------------------
// Role-picker data layer.
//
// All reads come from the bot-maintained discord_guild_roles mirror
// (table added in migration 0041) via direct supabase-js calls under RLS.
// Mirrors discord-channels-data.ts; the picker UI itself lands in
// Story 10B (the `recruit` feedback-form field).
// ---------------------------------------------------------------------------

export async function fetchDiscordGuildRoles(
  connectionId: string,
): Promise<DiscordGuildRole[]> {
  const { data, error } = await supabase
    .from('discord_guild_roles')
    .select(DISCORD_GUILD_ROLE_CLIENT_COLUMNS_CSV)
    .eq('connection_id', connectionId)
    // Discord renders the role list highest-first (highest role on top in
    // server settings). Mirror that here so the picker matches what the
    // dev sees in their server.
    .order('position', { ascending: false })
    .order('name', { ascending: true });

  if (error !== null) {
    console.warn('[discord-roles-data] fetch failed:', error.message);
    return [];
  }
  if (data === null) return [];

  const out: DiscordGuildRole[] = [];
  for (const row of data) {
    const parsed = DiscordGuildRoleRowResponseSchema.safeParse(row);
    if (parsed.success) {
      out.push(parsed.data);
    } else {
      console.warn('[discord-roles-data] could not parse row:', parsed.error.issues);
    }
  }
  return out;
}
